import { Select, Space } from "antd";
import React from "react";
import YearIndicators from "../YearIndicators";

const HeatMapFilters = ({
  species,
  selectedSpecies,
  loading,
  speciesChangeHandler,
  camera,
  selectedCamera,
  cameraChangeHandler,
  isTiger,
  selectedTiger,
  tigerSelectionHandler,
  tigerslist,
  detailTigerView,
  isYearlyTigerChecked,
  handleYearlyTigerRadioChange,
  isTigerNetworkChecked,
  handleTigerNetworkRadioChange,
}) => {
  return (
    <div>
      <div className="filter-options">
        <div className="DirectionDropdown" style={{ width: "100%" }}>
          <label htmlFor="">Species</label>
          <Select
            showSearch
            style={{ width: 200 }}
            placeholder="Select"
            optionFilterProp="children"
            loading={(species !== null && species.length === 0) || loading}
            size={"large"}
            value={selectedSpecies}
            onChange={speciesChangeHandler}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={species}
          />
        </div>
        <div className="DirectionDropdown" style={{ width: "100%" }}>
          <label htmlFor="">Station ID</label>
          <Space direction="vertical" style={{ width: "100%" }}>
            <Select
              mode="multiple"
              size="large"
              style={{ width: "100%" }}
              options={camera}
              loading={(species !== null && species.length === 0) || loading}
              value={selectedCamera}
              onChange={cameraChangeHandler}
              placeholder="Select Item..."
              maxTagCount="responsive"
            />
          </Space>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "left",
          justifyContent: "space-between",
        }}
      >
        {isTiger && (
          <div className="filter-options">
            <div className="DirectionDropdown" style={{ width: "100%" }}>
              <label htmlFor="">Tiger Name</label>
              <Select
                showSearch
                style={{ width: 200 }}
                placeholder="Select"
                optionFilterProp="children"
                size={"large"}
                value={selectedTiger}
                onChange={tigerSelectionHandler}
                allowClear={true}
                loading={(species !== null && species.length === 0) || loading}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={tigerslist}
              />
            </div>
          </div>
        )}
        {selectedTiger && (
          <div
            className="Login_Button upload_button"
            style={{ width: "48.5%", marginTop: "2vh" }}
          >
            <button onClick={detailTigerView}>Detailed View</button>
          </div>
        )}
      </div>
      <div>
        {selectedTiger && (
          <div
            style={{
              paddingLeft: "0.1vw",
              marginTop: "1vh",
              display: "flex",
              gap: "0.5vw",
            }}
          >
            <input
              type="checkbox"
              id="tigerOption"
              name="animalOption"
              checked={isYearlyTigerChecked}
              onChange={handleYearlyTigerRadioChange}
            />
            <label htmlFor="tigerOption">Yearly Tiger View</label>
          </div>
        )}
      </div>
      {selectedTiger && isYearlyTigerChecked && !isTigerNetworkChecked && (
        <YearIndicators />
      )}
      <div>
        {selectedTiger && (
          <div
            style={{
              paddingLeft: "0.1vw",
              marginTop: "3vh",
              display: "flex",
              gap: "0.5vw",
            }}
          >
            <input
              type="checkbox"
              id="tigerOption"
              name="animalOption"
              checked={isTigerNetworkChecked}
              onChange={handleTigerNetworkRadioChange}
            />
            <label htmlFor="tigerOption">View Tiger Movement</label>
          </div>
        )}
      </div>
    </div>
  );
};

export default HeatMapFilters;
